import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import translate from '../../libs/i18n';

import {
  userShape,
  institutionPermissionsShape,
} from '../../utils/propTypesShapes';

import { UsersListStyle } from './UsersListStyle';

import UserListItem from '../UserListItem/UserListItem';
import EmptyListWarning from '../EmptyListWarning/EmptyListWarning';

const UsersList = ({
  usersList,
  handleDeleteUser,
  handleCatchUserDataForEdition,
  institutionPermissions,
  setUserActionComplete,
  loading,
}) => {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    setUsers(usersList);
  }, [usersList]);

  const language = useSelector((state) => state.settings.language);

  return (
    <UsersListStyle>
      <div className="users-list-table-head">
        <div className="name-item table-head-item">{translate('name',language)}</div>
        <div className="matriculation-item table-head-item">{translate('matriculation',language)}</div>
        <div className="role-item table-head-item">Role</div>
        <div className="registration-date-item table-head-item">
          {translate('registrationDate',language)}
        </div>
        <div className="patient-data-item table-head-item">{translate('addExams',language)}</div>
        <div className="images-exams-item table-head-item">{translate('seeResults',language)}</div>
        <div className="report-results-item table-head-item">
          {translate('approveReports',language)}
        </div>
        <div className="actions-item table-head-item">{translate('actions',language)}</div>
      </div>
      {users && users.length ? (
        users.map((user, index) => {
          return (
            <UserListItem
              userItem={user}
              handleDeleteUser={handleDeleteUser}
              handleCatchUserDataForEdition={handleCatchUserDataForEdition}
              institutionPermissions={institutionPermissions}
              setUserActionComplete={setUserActionComplete}
              loading={loading}
              key={index}
            />
          );
        })
      ) : (
        <EmptyListWarning
          messages={{
            firstMessage: translate('noResults', language),
            secondMessage: translate('noActiveUser', language),
              
          }}
        />
      )}
    </UsersListStyle>
  );
};

UsersList.propTypes = {
  usersList: PropTypes.arrayOf(userShape),
  handleDeleteUser: PropTypes.func.isRequired,
  handleCatchUserDataForEdition: PropTypes.func.isRequired,
  institutionPermissions: PropTypes.arrayOf(institutionPermissionsShape)
    .isRequired,
  setUserActionComplete: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

UsersList.defaultProps = {
  usersList: [],
};
export default UsersList;
